/** WebApp2 stub：对齐 Mobile `isDictationTaggedText` 接口，非听写场景恒 false。 */
export function isDictationTaggedText(_text: string): boolean {
  return false;
}
